import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "./pages/components/Header";
import Footer from "./pages/components/Footer";
import Preloader from "./pages/components/Preloader";
import ScrollTop from "./pages/components/ScrollTop";
import MobileMenu from "./pages/components/MobileMenu";
import SearchOverlay from "./pages/components/SearchOverlay";
import BreadCrumb from "./pages/components/BreadCrumb";
import RouteErrorBoundary from "./pages/components/ErrorBoundary/ErrorBoundary";
import "./App.css";
import NavigationProvider from "./contexts/Navigation";
import AppRoutes from "./routes";

const base = process.env.PUBLIC_URL + "/assets/js"; // Vite: use "/assets/js"

// Order matters: jQuery first, plugins next, main.js last
const SCRIPTS = [
  "vendor/modernizr-2.8.3.min.js",
  "vendor/jquery-3.5.1.min.js",
  "vendor/jquery-migrate-3.3.0.min.js",
  "vendor/bootstrap.min.js",
  "plugins/wow.min.js",
  "plugins/swiper.min.js",
  "plugins/lightgallery.min.js",
  "plugins/waypoints.min.js",
  "plugins/countdown.min.js",
  "plugins/isotope.min.js",
  "plugins/masonry.min.js",
  "plugins/images-loaded.min.js",
  "plugins/wavify.js",
  "plugins/jquery.wavify.js",
  "plugins/circle-progress.min.js",
  "plugins/counterup.min.js",
  "plugins/animation-text.min.js",
  "plugins/vivus.min.js",
  "plugins/some-plugins.js",
  "plugins/jquery.validate.min.js",
  "main.js",
];

function loadScript(path) {
  return new Promise((resolve, reject) => {
    const el = document.createElement("script");
    el.src = `${base}/${path}`;
    el.async = false;
    el.dataset.template = "true";
    el.onload = resolve;
    el.onerror = () => reject(new Error(`Failed to load ${path}`));
    document.body.appendChild(el);
  });
}

function App() {
  const started = useRef(false);
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (started.current) return; // prevents double load in StrictMode
    started.current = true;

    (async () => {
      for (const path of SCRIPTS) {
        try {
          await loadScript(path);
        } catch (e) {
          console.error(e);
        }
      }
      setLoading(false); // all scripts finished, hide the preloader
    })();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  const reportToYourLogger = (error, info, errorId) => {};

  return (
    <React.Fragment>
      {loading && <Preloader />}

      <NavigationProvider pathname={pathname}>
        <Header />
      </NavigationProvider>

      <RouteErrorBoundary
        onError={(error, info, errorId) =>
          reportToYourLogger(error, info, errorId)
        }
      >
        <BreadCrumb />

        <div id="main-wrapper">
          <AppRoutes />
          <ScrollTop />
          <MobileMenu />
          <SearchOverlay />
        </div>
      </RouteErrorBoundary>

      <Footer />
    </React.Fragment>
  );
}

export default App;
